import { PropType, SetupContext } from 'vue'
import { v4 as uuidv4 } from 'uuid'

interface Props {
  options: Record<string, string>[];
  name: string;
  label: string;
  placeholder: string;
  searchPlaceholder: string;
  modelValue: string | number;
  search: boolean;
}

export const props = {
  options: {
    type: Array as PropType<Record<string, string>[]>,
    default: () => []
  },
  name: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: null
  },
  placeholder: {
    type: String,
    default: null
  },
  searchPlaceholder: {
    type: String,
    default: null
  },
  modelValue: {
    type: [String, Number],
    default: null
  },
  search: {
    type: Boolean,
    default: false
  }
}

export const emits = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  'update:modelValue': (payload: string): boolean => true
}

export default function (props: Props, emit: SetupContext<typeof emits>['emit']) {
  const selectId = uuidv4()

  function onInput (val) {
    emit('update:modelValue', val)
  }

  return {
    selectId,
    onInput
  }
}
